import React from "react";
import { Button } from "semantic-ui-react";

import Alarms1_PSM2 from "./Alarms1_PSM2";
import Alarms2_PSM2 from "./Alarms2_PSM2";
import Alarms3_PSM2 from "./Alarms3_PSM2";
import Alarms4_PSM2 from "./Alarms4_PSM2";
import Alarms5_PSM2 from "./Alarms5_PSM2";

const Alarms_PSM2 = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Alarms1_PSM2 />;
      case "2":
        return <Alarms2_PSM2 />;
      case "3":
        return <Alarms3_PSM2 />;
      case "4":
        return <Alarms4_PSM2 />;
      default:
        return <Alarms1_PSM2 />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="ALARMS PAGE - 1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="ALARMS PAGE - 2"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="ALARMS PAGE - 3"
        />
        <Button
          size="medium"
          id="4"
          active={toggleButton === "4"}
          onClick={handleClick}
          content="ALARMS PAGE - 4"
        />
        {/* <Button
                    size='medium'
                    id='5'
                    active={toggleButton==='5'}
                    onClick={handleClick}
                    content='ALARMS PAGE - 5'
                /> */}
        {/* <Button
                    size='medium'
                    id='6'
                    active={toggleButton==='6'}
                    onClick={handleClick}
                    content='ALARMS PAGE - 6'
                />
                <Button
                    size='medium'
                    id='7'
                    active={toggleButton==='7'}
                    onClick={handleClick}
                    content='ALARMS PAGE - 7'
                />
                <Button
                    size='medium'
                    id='8'
                    active={toggleButton==='8'}
                    onClick={handleClick}
                    content='ALARMS PAGE - 8'
                /> */}
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default Alarms_PSM2;
